import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-wallet2-icon',
  templateUrl: './shopping-wallet2.component.html'
})
export class ShoppingWallet2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
